import React from "react";

export const Products = () => {
  return (
    <div>
      <h1>Products</h1>
    </div>
  );
};
